









































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPopup,
    DxForm,
    DxPatternRule
} from 'devextreme-vue/data-grid';
import { DxItem } from 'devextreme-vue/form';
import { DataSource } from '@/types';
import {
    Table,
    defaultTableConfig,
    TableConfig
} from '@/core/components/table';
import {
    CONTRACTS,
    WindowsServiceContract,
    FetchServiceContract
} from '@/core/contracts';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { Site } from '@/dto';
import { ContextsState } from '@/store';
import { localize } from '@/core/filters';
import DevExpress from 'devextreme/bundles/dx.all';

@Component({
    components: {
        DxDataGrid,
        DxColumn,
        DxEditing,
        DxPopup,
        DxForm,
        DxItem,
        DxPatternRule
    }
})
export default class SitesListTable extends Vue {
    @Prop({ type: String, required: true }) public tableKey!: string;
    @Prop({ type: Object, required: true }) public dataSource!: DataSource;

    @Inject(CONTRACTS.WindowsService)
    private _windowsService?: WindowsServiceContract;
    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;

    private timeSpanPattern: RegExp = /^((((?:-?0*\d+\.)?(?:0*)(?:2[0-3]|1[0-9]|[0-9]))(?::0*([0-5]?[0-9]))?(?::0*((?:[0-5]?[0-9])(?:\.\d{0,7})?)))|(\d+))?$/;

    public get timeSpanValidateMessage(): string {
        return localize('SitesList_TimeSpanValidateMessage');
    }

    public get defaultTableConfig(): Partial<TableConfig> {
        return defaultTableConfig(this);
    }

    public async mounted() {
        // raise instance of the table up to parent
        this.$emit('setTableInstance', this.tableInstance);
    }

    public get tableInstance(): Table {
        const element = this.$refs['data-grid'] as unknown;
        return (element as DxDataGrid).instance!;
    }

    public get localize() {
        return localize;
    }

    public getDataGridInstance(): Table {
        const element = this.$refs['data-grid'] as unknown;
        return (element as DxDataGrid).instance!;
    }

    public deleteSite() {
        this._windowsService!.showDialog(localize('SiteSimpleDeleteMessage'), [
            { id: 1, caption: localize('DialogYes') },
            { id: 2, caption: localize('DialogCancel') }
        ]).then(id => {
            if (id === 1) {
                const site = this.tableInstance.getSelectedRowsData()[0];
                const data = {
                    Sites_Partial: [
                        {
                            id: site.id,
                            IsDeleted: true
                        }
                    ]
                };
                const currentContextId = ContextsState.currentContextId;
                const url = `/files/contexts/${currentContextId}?ignoreWarnings=true`;
                this._fetchService!.post<Site>(
                    url,
                    JSON.stringify(data)
                ).then(() => this.getDataGridInstance().refresh());
            }
        });
    }

    private initNewRow(row: any) {
        row.data.isVisible = true;
    }
}
